import { subDays } from 'date-fns';

export const getCalendarStartingDate = (currentDate: Date): Date => {
  // JavaScriptのgetDay は日曜が0
  if (currentDate.getDay() == 0) {
    // Ucareのカレンダーは月曜はじまりで、JavaScriptのgetDayでは補正できない
    // なので、currentDateが日曜日の場合は6日巻き戻す
    return subDays(currentDate, 6);
  } else {
    // currentDateが日曜日でなければ、
    // (曜日の数字 - 1)日巻き戻す
    const daysToSub = currentDate.getDay() - 1;
    return subDays(currentDate, daysToSub);
  }
};

export const getDatesOfOneWeek = (monday: Date): Date[] => {
  const result: Date[] = [];
  for (let i = 0; i < 7; i++) {
    const newDate = new Date(monday.getTime());
    newDate.setDate(monday.getDate() + i);
    result.push(newDate);
  }
  return result;
};
